import { RNA_TYPES, RNA_VALUES } from '@/assets/data/RNATypes';
import { DATA_TYPES, DATA_VALUES } from '@/assets/data/DataTypes';

const SEARCH_SYMBOL_RNA_VALUES = [
  RNA_VALUES[RNA_TYPES.codingRNA],
  RNA_VALUES[RNA_TYPES.lncRNA],
  RNA_VALUES[RNA_TYPES.circRNA],
  RNA_VALUES[RNA_TYPES.miRNA],
];
const SEARCH_ID_RNA_VALUES = [RNA_VALUES[RNA_TYPES.piRNA], RNA_VALUES[RNA_TYPES.tRFRNA]];
export { SEARCH_ID_RNA_VALUES, SEARCH_SYMBOL_RNA_VALUES };

// same constant as backend code
const COLUMNS_MAP = {
  [RNA_VALUES[RNA_TYPES.codingRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_symbol',
      '3',
      '4',
      '6',
      '12',
      '11',
      '20',
      '9',
      '16',
      '15',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_symbol',
      '3',
      '4',
      '6',
      '12',
      '11',
      '20',
      '9',
    ],
  },
  [RNA_VALUES[RNA_TYPES.lncRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_symbol',
      '3',
      '4',
      '6',
      '12',
      '11',
      '20',
      '9',
      '15',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_symbol',
      '3',
      '4',
      '6',
      '12',
      '11',
      '20',
      '9',
    ],
  },
  [RNA_VALUES[RNA_TYPES.miRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_symbol',
      '1',
      '2',
      '4',
      '7',
      '8',
      '12',
      '10',
      '13',
      '14',
      '18',
      '19',
      '23',
      '24',
      '25',
      '15',
      '6',
      '9',
      '20',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_symbol',
      '1',
      '2',
      '4',
      '6',
      '7',
      '9',
      '8',
      '12',
      '10',
      '13',
      '14',
      '18',
      '20',
      '19',
      '23',
      '24',
      '25',
      '21',
      '22',
    ],
  },
  [RNA_VALUES[RNA_TYPES.circRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_id',
      'gene_symbol',
      'genomic_position',
      'circBase_id',
      '6',
      '11',
      '20',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_id',
      'gene_symbol',
      'genomic_position',
      'circBase_id',
      '6',
      '11',
      '20',
    ],
  },
  [RNA_VALUES[RNA_TYPES.piRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_id',
      '2',
      '6',
      '14',
      '20',
      '21',
      '22',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_id',
      '6',
      '14',
      '20',
      '21',
      '22',
    ],
  },
  [RNA_VALUES[RNA_TYPES.tRFRNA]]: {
    [DATA_VALUES[DATA_TYPES.expression]]: [
      'gene_id',
      '2',
      '6',
      '14',
      '20',
      '21',
      '22',
      '17',
    ],
    [DATA_VALUES[DATA_TYPES.diffExpression]]: [
      'gene_id',
      '6',
      '14',
      '20',
      '21',
      '22',
    ],
  },
};
export { COLUMNS_MAP as HEADERS_MAP };

export const META_INFO = {
  gene_symbol: {
    name: 'Gene symbol',
  },
  gene_id: {
    name: 'Gene ID',
  },
  genomic_position: {
    name: 'Genomic position',
  },
  circBase_id: {
    name: 'circBase ID',
  },
  1: {
    name: 'BorderlineOvarianTumor(blood)',
    tumorType: 'BorderlineOvarianTumor',
  },
  2: {
    name: 'Breast cancer(blood)',
    tumorType: 'Breast cancer',
  },
  3: {
    name: 'Breast cancer(CTCs)',
    tumorType: 'Breast cancer',
  },
  4: {
    name: 'Colorectal cancer(blood)',
    tumorType: 'Colorectal cancer',
  },
  5: {
    name: 'Colorectal cancer(CTCs)',
    tumorType: 'Colorectal cancer',
  },
  6: {
    name: 'Colorectal cancer(EVS)',
    tumorType: 'Colorectal cancer',
  },
  7: {
    name: 'Esophageal cancer(blood)',
    tumorType: 'Esophageal cancer',
  },
  8: {
    name: 'Gastric cancer(blood)',
    tumorType: 'Gastric cancer',
  },
  9: {
    name: 'Glioblastoma(EVS)',
    tumorType: 'Glioblastoma',
  },
  10: {
    name: 'Liver cancer(blood)',
    tumorType: 'Liver cancer',
  },
  11: {
    name: 'Liver cancer(EVS)',
    tumorType: 'Liver cancer',
  },
  12: {
    name: 'Lung cancer(blood)',
    tumorType: 'Lung cancer',
  },
  13: {
    name: 'MultipleMyeloma(blood)',
    tumorType: 'MultipleMyeloma',
  },
  14: {
    name: 'MultipleMyeloma(EVS)',
    tumorType: 'MultipleMyeloma',
  },
  15: {
    name: 'Normal(blood)',
    tumorType: 'Normal',
  },
  16: {
    name: 'Normal(CTCs)',
    tumorType: 'Normal',
  },
  17: {
    name: 'Normal(EVS)',
    tumorType: 'Normal',
  },
  18: {
    name: 'Ovarian cancer(blood)',
    tumorType: 'Ovarian cancer',
  },
  19: {
    name: 'Pancreatic cancer(blood)',
    tumorType: 'Pancreatic cancer',
  },
  20: {
    name: 'Pancreatic cancer(EVS)',
    tumorType: 'Pancreatic cancer',
  },
  21: {
    name: 'Prostate cancer(EVS)',
    tumorType: 'Prostate cancer',
  },
  22: {
    name: 'Renal cell carcinoma(EVS)',
    tumorType: 'RenalCellCarcinoma',
  },
  23: {
    name: 'Retinoblastoma(blood)',
    tumorType: 'Retinoblastoma',
  },
  24: {
    name: 'Sarcoma(blood)',
    tumorType: 'Sarcoma',
  },
  25: {
    name: 'Wilms Tumor(blood)',
    tumorType: 'Wilms Tumor',
  },
};

export const GENE_LISTS = {
  'Adhesion and Matrix Proteins': ['Acronym', 'asporin', 'CRT', 'CEAM6', 'CAM17.1', 'CLI', 'ICTP', 'CDH1', 'EpCAM', 'HYAL-1', 'HYuA', 'LMNB1', 'MMP9', 'MMP2', 'MMP7', 'TIMP1', 'OPN', 'PAM4', 'P1NP', 'TIMP-4', 'sICAM-1', 'SMRP', 'SP-D', 'TRACP5b', 'TNC', 'VIM', 'Fib3'],
  'Auto-antibodies & Immunological Markers': ['p53', 'MUC1', 'MUC5AC', 'IMPDH', 'HSP70', 'IgG ', 'IgA ', 'ECPKA', 'B7-H4', 'IgM', 'TgAb', 'HSP60', 'PRDX1', 'PDRX2', 'GFAP', 'CRP', 'ApoA-1', 'CD61', 'B7H3', 'sLeX', 'KL-6', 'MAPK9', 'sMICA', 'sMICB', 'CD23', 'CD27', 'CD30', 'CD63', 'CD24', 'IL2RB', 'LY9', 'CFAB', 'NY-ESO-1', 'CAGE', 'GBU4-5', 'SOX2', 'HuD', 'Bmi-1', 'FOXP3', 'CTDSP1', 'MAPK9', 'NR2E3'],
  'Classical Tumour Markers': ['PSA', 'CA153', 'CEA', 'AFP', 'LDH', 'HE4', 'CA125', 'CA199', 'SCCA', 'CA9', 'CYFRA21-1', 'NSE', 'LEP', 'ProGRP', 'CA724', 'TYR', 'IGM', 'PCA3', 'ADA', 'GGT', 'ALP', 'HER2', 'PSMA'],
  'Coagulation and Angiogenesis Molecules': ['UPA', 'VEGF', 'ANXA4', 'HBA1', 'HBA2', 'HBB', 'DCP', 'KLK10', 'KNG1', 'KLK4', 'ET1', 'PAI1', 'KLK6', 'ANGPT2', 'THBS1', 'PAI', 'PAR1', ' PAR2', 'F5', 'DCP', 'ENDOSTAIM', 'PlGF', 'ANXA1', 'NES', 'ESM1', 'C4D', 'ANXA2', 'PEDF', 'THBDM', 'ANXA3', 'VWF'],
  'Cytokines, Chemokines and Insulin-like Growth Factors': ['IL2', 'IL6', 'IL8', 'IL10', 'IL12', 'IL18', 'TNF', 'TGFB1', 'IFNG', 'MIF', 'CXCR4', 'KLK2', 'MIC1', 'CSF1', 'CSF2', 'CSF3', 'GP73', 'EGFR', 'IGFBP2', 'HGF', 'IGFBP3', 'GCSF', 'IL3', 'SCF', 'IGFI', 'IGFBP1', 'CCL5', 'BDNF', 'CXCL1', 'IL1ra', 'MCP1', 'CXCL9', 'MDK', 'IL33', 'GDF15', 'CCL11', 'CCL18', 'IL16', 'RANTES', 'IRF1', 'STNFR1', 'IL4', 'IL13', 'CXCL13', 'TGFA', 'CXCL10', 'IL27', 'MSPA', 'PDGFRA', 'HBEGF', 'NGF', 'TNFAIP6', 'MIP4', 'MPF'],
  'Circulating-free DNA': ['FHIT', '3p loci', 'APC', 'CHD1', 'MGMT', 'DCC', 'RASSF1A', 'AIM1', 'SEPT9', 'BARD1', 'BARD1', 'BARD1', 'mtDNA', 'FR3A', 'TVG', 'GSTP1', 'CYCD2', 'HIC1', 'PAX 1', 'RB1', 'SRBC', 'FAM5C', 'MYLK', 'GAPDH', 'RARB', 'ARF', 'PTGS2', 'PTGS2', 'SLC5A8', 'SLC26A4', 'BRAF', 'RARbeta2', 'TERT', 'LINE1', 'LINE1', 'ALU', 'ALU', 'BNC1', 'ADAMTS1'],
  Hormones: ['CGB3', 'CGB5', 'CGB8', 'G17', 'HTR4', 'RARB', 'E2', 'HPAA', 'PRB', 'CBG', 'FSHR', 'FSHB', 'CALCR', 'PRL'],
  'Metabolic markers': ['FGQTL1', 'CPG', 'MACF1', 'APOH', 'A2M', 'IGL', 'VDB', 'LPC', 'GCDCA', 'GCA', 'GDCA', 'TCA', 'TCDCA', 'TCA', 'DUPAN2', 'SPAN1', 'TSA', 'LSA', 'NG1A2F', 'C9', 'UA', 'TF', 'MPO', 'LOOH', 'ALU', 'MTOR', 'LPC', 'LPC', 'LPC', 'LPC', 'TC', 'HDLC', '5-mC', 'FAS', 'FTL', 'LPC', 'LPC', '5-HIAA'],
  'MicroRNA and other RNAs': ['has-let-7a', 'has-let-7c', 'has-let-7e', 'has-let-7f', 'has-miR-101', 'has-miR-103', 'has-miR-106a', 'has-miR-106b', 'has-miR-10b', 'has-miR-122', 'has-miR-1246', 'has-miR-1253', 'has-miR-1254', 'has-miR-126', 'has-miR-1260', 'has-miR-127-3p', 'has-miR-1280', 'has-miR-1283', 'has-miR-128b', 'has-miR-129', 'has-miR-129-2', 'has-miR-1290', 'has-miR-1303', 'has-miR-1308', 'has-miR-130b', 'has-miR-132', 'has-miR-1322', 'has-miR-133a', 'has-miR-133b', 'has-miR-135a', 'has-miR-135b', 'has-miR-136', 'has-miR-139-5p', 'has-miR-140', 'has-miR-141', 'has-miR-142-5p', 'has-miR-143', 'has-miR-145', 'has-miR-145-5p', 'has-miR-1468', 'has-miR-146a', 'has-miR-146b-3p', 'has-miR-148b', 'has-miR-150', 'has-miR-150-5p', 'has-miR-151-3p', 'has-miR-151-5p', 'has-miR-153', 'has-miR-155', 'has-miR-159a', 'has-miR-15a', 'has-miR-15b', 'has-miR-16', 'has-miR-16-1', 'has-miR-17', 'has-miR-17-3p', 'has-miR-17-5p', 'has-miR-181a', 'has-miR-181c', 'has-miR-182', 'has-miR-183', 'has-miR-184', 'has-miR-185', 'has-miR-186', 'has-miR-187', 'has-miR-188-3p', 'has-miR-18a', 'has-miR-190', 'has-miR-191', 'has-miR-191-5p', 'has-miR-192', 'has-miR-193a-3p', 'has-miR-193a-5p', 'has-miR-193b*', 'has-miR-195', 'has-miR-195-5p', 'has-miR-196a', 'has-miR-196a2', 'has-miR-197', 'has-miR-1973', 'has-miR-198', 'has-miR-199a-3p', 'has-miR-199a-5p', 'has-miR-199b', 'has-miR-200a', 'has-miR-200b', 'has-miR-200c', 'has-miR-200c/141', 'has-miR-202', 'has-miR-203', 'has-miR-204', 'has-miR-205', 'has-miR-20a', 'has-miR-21', 'has-miR-210', 'has-miR-211', 'has-miR212', 'has-miR-212- 3p', 'has-miR-214', 'has-miR-215', 'has-miR-216', 'has-miR-218', 'has-miR-219', 'has-miR-22', 'has-miR-220', 'has-miR-220c', 'has-miR-221', 'has-miR-222', 'has-miR-223', 'has-miR-23a', 'has-miR-23a-3p', 'has-miR-23b', 'has-miR-24', 'has-miR-25', 'has-miR-25-3p', 'has-miR-26a', 'has-miR-26a-2*', 'has-mir-26b', 'has-miR-26b-5p', 'has-miR-27a', 'has-miR-27b', 'has-miR-299-3p', 'has-miR-299-5p', 'has-miR-29a', 'has-miR-29c', 'has-miR-301', 'has-miR-302', 'has-miR-302a', 'has-miR-302b', 'has-miR-302c', 'has-miR-30a-5p', 'has-miR-30b', 'has-miR-30c', 'has-miR-30c-1*', 'has-miR-31', 'has-miR-32', 'has-miR-320', 'has-miR-320c', 'has-miR-324-3p', 'has-miR-324-5p', 'has-miR-328', 'has-miR-329', 'has-miR-33', 'has-miR-330', 'has-miR-330-5p', 'has-miR-331', 'has-miR-331-3p', 'has-miR-331-5p', 'has-miR-337-3p', 'has-miR-339-3p', 'has-miR-339-5p', 'has-miR-340', 'has-miR-342', 'has-miR-342-3p', 'has-miR-342-5p', 'has-miR-345', 'has-miR-346', 'has-miR-34a', 'has-miR-34a*', 'has-miR-361', 'has-miR-362-3p', 'has-miR-363*', 'has-miR-368', 'has-miR-369-3p', 'has-miR-371~373', 'has-miR-371a-3p', 'has-miR-372', 'has-miR-373', 'has-miR-375', 'has-mir-376c', 'has-miR-377', 'has-miR-378', 'has-miR-409-3p', 'has-miR-411', 'has-miR-423-5p', 'has-miR-451', 'has-miR-452', 'has-miR-483-5p', 'has-miR-484', 'has-miR-492', 'has-miR-494', 'has-miR-505', 'has-miR-520c-3p', 'has-miR-541', 'has-miR-548-5p', 'has-miR-548as-3p', 'has-miR-548b', 'has-miR-550', 'has-miR-566', 'has-miR574-3p', 'has-miR-574-5p', 'has-miR-576-3p', 'has-miR-590-5p', 'has-miR-601', 'has-miR-603', 'has-miR-616*', 'has-miR-625*', 'has-mir-636', 'has-miR-645', 'has-miR-652', 'has-miR-655', 'has-miR-656', 'has-miR-660', 'has-miR-660-5p', 'has-miR-661', 'has-miR-7', 'has-miR-720', 'has-miR-744', 'has-mir-760', 'has-miR-769-3p', 'has-miR-801', 'has-miR-876-3p', 'has-miR-885-5p', 'has-miR-890', 'has-miR-892a', 'has-miR-9', 'has-miR-92', 'has-miR-92a', 'has-miR-93', 'has-miR-939', 'has-miR-99a', 'has-miR-99b', 'has-let-7', 'has-miR-let-7i', 'has-miR-RNU44', 'has-miRNA-337-3p', 'has_piR_823', 'has_piR_651', 'TERT'],
  'Novel Proteins': ['TPS', 'TSGF', 'HP', 'CA242', 'GPC3', 'MAGEA3', 'FLNA', 'CRISP3', 'PGR', 'PON1', 'MAPRE1', 'LRG1', 'LCN2', 'P37', 'LARP1', 'ULBP2', 'CD9', 'CD81', 'REG4', 'PCBP1', 'BC200', 'TFPI', 'STMN1', 'CTDSP1', 'EFNA1', 'EphA2', 'CK20', 'TFF1', 'MUC2', 'NECTIN4', 'FABP7', 'STIP1', 'APOA1', 'HMGA1', 'TFDP1', 'SUV39H1', 'RBL1', 'HNRPD', 'AFU', 'CGA', 'LBP', 'PRG4', 'PLP', 'HPC1', 'TMPRSS2', 'ETS', 'AMACR', 'GOLPH2', 'EPCA', 'SLPI', 'ENO1', 'HMBG1', 'AGR2', 'CTAPIII', 'APOJ', 'DKK1', 'PTX3', 'FTH1', 'AHSG', 'BMP2', 'LOX', 'LGALS4', 'LRRIQ4', 'SIAH2', 'GCNT1', 'CACNAG1', 'C7orf24', 'DR3', 'MS4A', 'PDI', 'CENPF', 'WDR1', 'OPG', 'NNMT', 'CCSA-2', 'GAL3', 'PAK2', 'PHB2', 'RACK1', 'RUVBL1', 'C9orf50-M', 'CLEC4D', 'LMNB1', 'PRRG4', 'VNN1', 'HSP90', 'LRIG3', 'PTN', 'PRKCI', 'RGMC', 'SCFR', 'YES1', 'APO10', 'TKTL1', 'FLNB', 'DK', 'FAP', 'HRG', 'SSBP2', 'CA5B', 'F5', 'TBC1D8', 'ARG1', 'ADAMTS20', 'DAPK', 'HCCR', 'LPC1', 'HMGB1', 'PKM', 'HSP27', 'CA50', 'A1AG1', 'AACT', 'CERU', 'SPON2', 'TTR', 'SAA', 'NID2', 'CA211', 'CTX', 'OC', 'APOC1', 'LCN2', 'AFPL3', 'PCSK6', 'PCSA', 'A1BG', 'SAP', 'YB1', 'NPC2', 'CT16', 'TK1', 'A1AT', 'YKL40', 'PROSTASIN', 'ERP29', 'CE1', 'HABP'],
  'Nuclear Proteins': ['P16', 'KRAS', 'IDH1', 'P53', 'EBNA1', 'P15', 'NR2E3', 'SOX11', 'MITFM', 'E2F6', 'HNRNPF', 'TFIID', 'CIS1'],
  'Microbial Proteins': ['LMP2A', 'EBV', 'EBV', 'EBNA1', 'EBI3', 'OMP', 'HP0305', 'VACA'],
};
